export default "__VITE_PUBLIC_ASSET__852e662b__"